var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-layout',{staticClass:"item"},[_vm._t("replace",function(){return [(_vm.icon)?_c('n-icon',{staticClass:"span-1 icon",attrs:{"name":_vm.icon}}):_vm._e(),_c('n-text',{class:[_vm.icon ? 'span-5' : 'span-6']},[_vm._t("default")],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }